export default "__VITE_ASSET__Cth3c2tC__"